import { __rest, __assign } from './../../../external_lib/tslib/tslib.es6.js';
import React__default from 'react';
var BusinessAnalyticsFilled = function (_a) {
  var _b = _a.fill,
    fill = _b === void 0 ? 'currentColor' : _b,
    props = __rest(_a, ["fill"]);
  return React__default.createElement("svg", __assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React__default.createElement("path", {
    d: "M15.447 16.7808C15.84 16.2398 16.095 15.5258 16.116 14.6218L19.753 18.3048C20.958 16.8258 21.75 14.9998 21.949 12.9998H16V10.9998H21.949C21.479 6.28278 17.717 2.52078 13 2.05078V4.99978H11V2.05078C5.954 2.55378 2 6.82378 2 11.9998C2 17.5138 6.486 21.9998 12 21.9998C14.408 21.9998 16.619 21.1438 18.346 19.7218L15.447 16.7808ZM14.612 14.5698C14.612 16.0578 13.673 16.6288 13 16.8538V17.9998H11V16.9138C10.306 16.7188 9 16.0828 9 13.9998H10.873C10.873 15.5458 11.746 15.6168 11.879 15.6168C12.025 15.6168 12.739 15.5928 12.739 14.5818C12.739 12.5638 9.311 13.4598 9.311 10.4348C9.311 8.90878 10.328 8.33378 11 8.11978V6.99978H13V8.18478C13.635 8.47478 14.625 9.22578 14.625 10.9998H12.752C12.752 9.75678 12.174 9.39078 11.931 9.39078C11.798 9.39078 11.183 9.42278 11.183 10.4428C11.184 12.2238 14.612 11.6688 14.612 14.5698Z",
    fill: fill
  }));
};
export { BusinessAnalyticsFilled as default };
//# sourceMappingURL=BusinessAnalyticsFilled.js.map
